<template>
    <div class="menu-layer" :style="'top:' + y + '; left:' + x + ';'">
        <!-- <h1 class="title title-layer">{{$t('menulayer.title')}}</h1> -->
        <div class="layer-content-items">
            <div v-for="item in items" class="layer-content-item" @click="action(item);">
                <!-- <span class="icon-layer" :id="'icon-layer-lock-' + item.id"></span> -->
                <span class="icon-layer" :class="{ 'icon-layer-active': item.active === true, 'icon-layer-desactive': item.active === false }"></span>
                {{ $t(item.label) }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: Array,
        x: { type: String, default: "0px" },
        y: { type: String, default: "0px" }
    },
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {
        // this.activeLock()
    },
    methods: {
        action(item) {
            item.active = !item.active;
            // let locks = item.locks
            // this.activeLock()
            if (item.action) {
                if (item.action.args) {
                    let args = item.action.args;
                    args[1] = item.active;
                    item.action.func.apply(null, args);
                } else {
                    let args = [];
                    args[0] = item.active;
                    item.action.func.apply(null, args);
                }
            }
        },
        activeLock() {
            let items = this.items.filter(item => item.active === true);
            if (items.length === 0) return;
            // console.log(items)
            items.sort((item1, item2) => {
                return item2.priority - item1.priority;
            });

            let item = items[0];
            let locks = item.locks;
            let lock, elt;
            Object.keys(locks).forEach(key => {
                lock = locks[key];
                elt = document.querySelector("#icon-layer-lock-" + key);
                if (lock) {
                    elt.classList.add("icon-layer-lock");
                    elt.classList.remove("icon-layer-nolock");
                } else {
                    elt.classList.add("icon-layer-nolock");
                    elt.classList.remove("icon-layer-lock");
                }
                // console.log(key, locks[key])
            });
        }
    }
};
</script>

<style scoped lang="scss">
.menu-layer {
    border: 1px solid #d2d2d2;
    background-color: #fefefe;
    position: absolute;
    z-index: 2000;
    padding: 8px;

    .title-layer {
        background-color: #90bed8;
        color: #ffffff;
        margin: 0px 0px 8px 0px;
        padding: 3px 10px;
        font-size: 16px;
        /*font-weight: initial;*/
    }

    .layer-content-items {
        .layer-content-item {
            cursor: pointer;
            padding: 3px;
            border-bottom: 1px solid #d2d2d2;
            .icon-layer {
                display: inline-block;
                background-size: 25px;
                width: 25px;
                height: 20px;
                vertical-align: middle;
            }

            .icon-layer-active {
                background: url("../../assets/eye-visible.svg") no-repeat;
            }
            .icon-layer-desactive {
                background: url("../../assets/no-eye.svg") no-repeat;
            }

            .icon-layer-lock {
                background: url("../../assets/lock.svg") no-repeat;
            }
            .icon-layer-nolock {
                background: url("../../assets/no-lock.svg") no-repeat;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// MenuLayer.vue?9db51a96